import * as React from "react";

const LeftProps = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.95313 1.04687L1 6L5.95313 10.9531"
      stroke={props.stroke}
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
  </svg>
);
export default LeftProps;
